import Title from "../UI/Title/Title";
import { Breadcrumb, Col, DatePicker, Popover, Row } from "antd";
import { InformationList } from "./InformationList";
import "./style.css";
import { SummaryTable } from "./summary";
import { useState, ChangeEvent, createContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ResetButton from "../UI/ResetButton/resetbutton";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Search } from "../UI/Search/Search";
import { useMutation } from "react-query";
import {
  Dto,
  Till,
  getTillBySessionId,
  getTillDetails,
  getTills,
} from "../../api/till";
import { useEffect } from "react";
import TransactionTable from "./TransactionTable";
function Information() {
  const { RangePicker } = DatePicker;
  const [key, setKey] = useState(0);
  const resetFilters = () => {
    setKey((prevKey) => prevKey + 1);
    setTableKey((tableKey) => tableKey + 1);
    setDto({
      ...Dto,
      q: "",
      openDateFrom: "",
      openDateTo: "",
      closeDateFrom: "",
      closeDateTo: "",
    });
  };
  const { t } = useTranslation("common");
  const [tableKey, setTableKey] = useState(0);
  const [info, setInfo] = useState<any>();
  const [Dto, setDto] = useState<Dto>({
    q: "",
    openDateFrom: "",
    openDateTo: "",
    closeDateFrom: "",
    closeDateTo: "",
    limit: 20,
  });
  const [tills, setTills] = useState<Till[]>([]);
  const sessionIdRef = useRef(localStorage.getItem("sessionId"));
  const initialSelectedTillId = Number(sessionIdRef.current); // Assuming session ID can be used as till ID
  const [selected, setSelected] = useState<number>(initialSelectedTillId);
  const { mutateAsync: getTillsMutation, isLoading: isTillsLoading } =
    useMutation("tillInfo", () => getTills(Dto), {
      onSuccess: (res) => {
        setTills(res?.data?.data);
      },
    });
  const { mutateAsync: getTillBySessionIdMutation } = useMutation(
    "tillInfoBySession",
    () => getTillBySessionId(sessionIdRef.current),
    {
      onSuccess: (res) => {
        setSelected(res.data.id);
      },
    }
  );
  const {
    mutateAsync: getTillDetailsMutation,
    isLoading: isTillDetailsLoading,
  } = useMutation("getCurrencyDenomination", () => getTillDetails(selected), {
    onSuccess: (res) => {
      setInfo(res.data.till);
    },
  });

  useEffect(() => {
    getTillBySessionIdMutation();
  }, [sessionIdRef.current]);

  useEffect(() => {
    const handleStorageChange = () => {
      sessionIdRef.current = localStorage.getItem("sessionId");
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const content = () => {
    return (
      <>
        <Col className="tillcolor">
          {`${t("date")}`}:<span className="datacolor"> {info?.Date}</span>
        </Col>
        <Col className="tillcolor">
          {t("session")}: {t("from")}{" "}
          <span className="datacolor"> {info?.startTime}</span>
          <span className="tillcolor"> {t('to')} </span>
          <span className="datacolor"> {info?.endTime || t("now")}</span>
        </Col>
        <Col className="tillcolor">
          {t("workstation")} :<span className="datacolor"> 1 </span>
        </Col>
      </>
    );
  };

  useEffect(() => {
    getTillBySessionIdMutation();
  }, [getTillBySessionIdMutation]);

  useEffect(() => {
    getTillsMutation();
  }, [getTillsMutation, Dto.closeDateFrom, Dto.closeDateTo, Dto.limit]);
  useEffect(() => {
    if (!Dto.q) getTillsMutation();
  }, [getTillsMutation, Dto.q]);
  useEffect(() => {
    getTillDetailsMutation();
  }, [getTillDetailsMutation, selected]);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col
          offset={1}
          span={20}
          style={{
            marginBottom: "10px",
          }}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("till-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("till-information")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={Dto?.q}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setDto({ ...Dto, q: e.target.value });
            }}
            onEnter={() => getTillsMutation()}
          />
        </Col>
        <Col span={6}>
          <RangePicker
            key={key}
            style={{ width: "100%" }}
            size="large"
            format={"MM/DD/YYYY"}
            placeholder={[t('start-date'), t('end-date')]}
            onChange={(dates: any, StringDate) => {
              if (dates === null || dates.length === 0) {
                // If the date range picker is cleared, reset the filters
                resetFilters();
              } else {
                setDto({
                  ...Dto,
                  closeDateFrom: `${StringDate[0]} 00:00:00`,
                  closeDateTo: `${StringDate[1]} 23:59:59`,
                });
              }
            }}
          />
        </Col>
        <Col
          offset={10}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}>
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <InformationList
            sessionIdRef={sessionIdRef}
            selected={selected}
            setSelected={setSelected}
            tableKey={tableKey}
            tills={tills}
            isTillsLoading={isTillsLoading}
            Dto={Dto}
            setDto={setDto}
            getTillsMutation={getTillsMutation}
          />
        </Col>
      </Row>

      <Row gutter={[10, 0]}>
        <Col
          offset={1}
          span={6}
          style={{
            color: "#162149",
            fontSize: "20px",
            fontWeight: "bold",
          }}>
          {t("transaction-stats")}
          <span>
            <Popover
              overlayClassName="custom-popover"
              content={content}
              placement="top"
              trigger="click"
              style={{ borderColor: "#1677FF" }}>
              <span>
                {" "}
                <InfoCircleOutlined
                  style={{
                    color: "#1677FF",
                    fontSize: "20px",
                    marginRight: "5px",
                  }}
                />
              </span>
            </Popover>
          </span>
        </Col>
      </Row>
      <Row>
        <Col offset={1} span={22} style={{ marginTop: "10px" }}>
          <TransactionTable selected={selected} />
        </Col>
      </Row>
    </>
  );
}

export default Information;
